import { Box } from '@chakra-ui/react';
import { Fragment  } from 'react';
import type { PropsWithChildren } from 'react';

import { Footer, NavbarContainer } from '@/modules/navigation';
import { FullBleedSection, SectionContent } from '@/modules/shared';

export const SiteShell = ({ children }: PropsWithChildren) => {
	return (
		<Fragment>
			<Box
				display="flex"
				flexDir="column"
				minH="100vh"
				position="relative"
			>
				<FullBleedSection
					as="header"
					bg="white"
					boxShadow="sm"
					position="sticky"
					top={0}
					zIndex={99}
				>
					<SectionContent py={6}>
						<NavbarContainer />
					</SectionContent>
				</FullBleedSection>
				<Box as="main" display="flex" flex={1} flexDir="column">
					{children}
				</Box>
			</Box>
			<FullBleedSection
				as="footer"
				bgGradient="footer"
				borderTop="1px solid {colors.gray.15}"
				boxShadow="sm"
			>
				<SectionContent>
					<Footer />
				</SectionContent>
			</FullBleedSection>
		</Fragment>
	);
};
